import { Box, Flex } from "@radix-ui/themes";
import { TIMELINE_ITEM_VIEW, TimelineItemView } from "../lib/consts";
import { SystemTimeCircleTooltip } from "./system-time-circle-tooltip";

interface TimelineItemProps {
  view: TimelineItemView;
  color: string;
  systemTime?: string;
  fetchedAt?: Date;
}

const TimelineItem = ({
  view,
  color,
  systemTime,
  fetchedAt,
}: TimelineItemProps) => {
  switch (view) {
    case TIMELINE_ITEM_VIEW.TRACK:
      return (
        <Flex height="100%" width="100%" justify="center">
          <Flex
            height="100%"
            flexGrow="1"
            style={{ backgroundColor: color }}
          ></Flex>
        </Flex>
      );

    case TIMELINE_ITEM_VIEW.EVENT_RANGE:
      return (
        <Flex height="100%" width="100%" align="center">
          <Flex
            height="17px"
            flexGrow="1"
            className="border-t border-b border-black"
            style={{ backgroundColor: color }}
          ></Flex>
        </Flex>
      );

    case TIMELINE_ITEM_VIEW.EVENT:
      return (
        <Flex height="100%" width="100%" align="center" justify="center">
          <Box
            height="12px"
            width="12px"
            className="border border-black rotate-45"
            style={{ backgroundColor: color }}
          ></Box>
        </Flex>
      );

    case TIMELINE_ITEM_VIEW.SYSTEM_TIME:
      return <SystemTimeBar color={color} />;

    case TIMELINE_ITEM_VIEW.SYSTEM_TIME_CIRCLE:
      return (
        <SystemTimeCircleTooltip
          color={color}
          systemTime={systemTime}
          fetchedAt={fetchedAt}
        />
      );

    default:
      return null;
  }
};

const SystemTimeBar = ({ color }: { color: string }) => {
  return (
    <div className="h-full w-full ">
      <div
        className="h-[2px]"
        style={{
          backgroundColor: color,
        }}
      ></div>
    </div>
  );
};

export default TimelineItem;
